import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG } from "./apiRoutes";

const mutateAddDocumentNumberRange = async ({
  documentTypeId,
  data,
}: {
  documentTypeId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${DOCUMENT_TYPE_CONFIG}/${documentTypeId}/number-ranges`,
    data
  );
};

const useAddDocumentNumberRangeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      documentTypeId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddDocumentNumberRange,
    ...queryParams,
  });

export default useAddDocumentNumberRangeMutation;
